<template>
  <header class="site-header plants-detail-header">
    <div class="plants-detail-header__row">
      <p class="site-header__brand">
        <a href="/" title="Plants4Pets" @click.prevent="scrollToTop">Plants4Pets</a>
      </p>
      <button
        type="button"
        class="plants-lang-switch"
        :aria-label="$t('switch_language')"
        @click="toggleLang"
      >{{ alternateLangLabel }}</button>
    </div>
    <h1 class="site-header__title">{{ $t('site_title') }}</h1>
    <p class="site-header__tagline">{{ $t('site_tagline') }}</p>
  </header>
</template>

<script>
import { usePlantStore } from '@/stores/plant-store'

export default {
  computed: {
    lang () {
      return usePlantStore().lang
    },
    alternateLang () {
      return this.lang === 'pl' ? 'en' : 'pl'
    },
    alternateLangLabel () {
      return this.alternateLang.toUpperCase()
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    toggleLang () {
      const store = usePlantStore()
      store.lang = this.alternateLang
      localStorage.setItem('lang', this.alternateLang)
      this.$root.$i18n.locale = this.alternateLang
      store.getPlants()
    }
  }
}
</script>
